class mRange extends HTMLDivElement {
    constructor() {
        super();
        this.lowerSlider = this.querySelector('.range-lower');
        this.upperSlider = this.querySelector('.range-upper');
        this.lowerVal = parseInt(this.lowerSlider.value, 10);
        this.upperVal = parseInt(this.upperSlider.value, 10);
    }

    connectedCallback() {
        this.lowerSlider.addEventListener('input', this.onLowerSliderInput);
        this.upperSlider.addEventListener('input', this.onUpperSliderInput);
    }

    disconnectedCallback() {
        this.lowerSlider.removeEventListener('input', this.onLowerSliderInput);
        this.upperSlider.removeEventListener('input', this.onUpperSliderInput);
    }

    onLowerSliderInput() {
        // keyword this is now the lower input itself
        const lowerVal = parseInt(this.value, 10);
        const upperVal = parseInt(this.parentElement.upperSlider.value, 10);

        if (upperVal < lowerVal - 4) {
            this.parentElement.upperSlider.value = lowerVal + 4;
            if (upperVal === this.parentElement.upperSlider.max) {
                // eslint-disable-next-line no-param-reassign
                this.value = parseInt(this.parentElement.upperSlider.max, 10) - 4;
            }
        }
    }

    onUpperSliderInput() {
        // keyword this is now the upper input itself
        const lowerVal = parseInt(this.parentElement.lowerSlider.value, 10);
        const upperVal = parseInt(this.value, 10);

        if (upperVal < lowerVal + 4) {
            this.parentElement.lowerSlider.value = upperVal - 4;
            if (lowerVal === this.parentElement.lowerSlider.min) {
                this.value = 4;
            }
        }
    }
}

customElements.define('m-range', mRange, {
    extends: 'div'
});

